(function() {
	"use strict";

	(function (factory) {
		var moduleName = "inlinejs";

		if (typeof ccs_define === "function") {
			ccs_define(
				moduleName,
				[
					"ccsJq",
					"fancybox",
					"ccsVideoPlayer",
					"slick",
					"CcsElementQueries"
				],
				factory);
			return;
		}

		var moduleExport = factory(ccsJq);
		if (typeof moduleExport !== "undefined") {
			window[moduleName] = moduleExport;
		}
	}
	(function () {
		/*
		this needs to execute all dependencies code.
		*/
	}));

	window.CcsInlineContent = function(options) {
/**
 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name) {
            name = name.split('/');
            lastIndex = name.length - 1;

            // If wanting node ID compatibility, strip .js from end
            // of IDs. Have to do this here, and not in nameToUrl
            // because node allows either .js or non .js to map
            // to same file.
            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
            }

            // Starts with a '.' so need the baseName
            if (name[0].charAt(0) === '.' && baseParts) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that 'directory' and not name of the baseName's
                //module. For instance, baseName of 'one/two/three', maps to
                //'one/two/three.js', but we want the directory, 'one/two' for
                //this normalization.
                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                name = normalizedBaseParts.concat(name);
            }

            //start trimDots
            for (i = 0; i < name.length; i++) {
                part = name[i];
                if (part === '.') {
                    name.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        name.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
            //end trimDots

            name = name.join('/');
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    //Creates a parts array for a relName where first part is plugin ID,
    //second part is resource ID. Assumes relName has already been normalized.
    function makeRelParts(relName) {
        return relName ? splitPrefix(relName) : [];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relParts) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0],
            relResourceName = relParts[1];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relResourceName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relResourceName));
            } else {
                name = normalize(name, relResourceName);
            }
        } else {
            name = normalize(name, relResourceName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i, relParts,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;
        relParts = makeRelParts(relName);

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relParts);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, makeRelParts(callback)).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

define("../../../../requirejs/almond", function(){});

define('ic/common',{
	rootBlockSelector: ".ccs-cc-inline",
	sectionSelector: ".ccs-cc-inline-section",
	mediaTypeAttr: "data-media-type",
	fancyboxTypeAttr: "data-fancybox-type",
	fancyboxHrefAttr: "data-fancybox-href",
	fancyboxGroupAttr: "data-fancybox-group",

	// gallery, features
	hoverLogCallAttr: "data-hover-log-call",

	// gallery, lightbox, video
	videoLogCallAttr: "data-video-log-call",
	errorLogCallAttr: "data-error-log-call",

	// features, video
	embeddedVideoSelector: ".ccs-cc-inline-embedded-video",
	noAutoplaySelector: ".ccs-cc-inline-noautoplay",

	// images
	imageSelector: ".ccs-cc-inline-thumbnail a.ccs-cc-inline-thumbnail-image",

	// videos
	videoSelector: ".ccs-cc-inline-thumbnail a.ccs-cc-inline-thumbnail-video"
});

define('ic/gallery/consts',["jquery", "ic/common"], function ($, common) {

	var c = {
		slickDefaults: { speed: 200, draggable: false, infinite: false },
		rootGallerySelector: ".ccs-cc-ig",
		thumbsContainer: ".ccs-slick-slider",
		slideSelector: ".ccs-slick-slide",
		cloudRoot: ".ccs-cc-ig-cloud",
		cloudViewport: ".ccs-cc-ig-cloud-viewport",
		cloudViewportArrow: ".ccs-ig-viewport-arrow",
		cloudActiveClass: "ccs-ig-cloud-active"
	}

	return $.extend(c, common);
});

define('ic/utils',["jquery", "./common"], function ($, common) {

	var c = {
		ensureStyleLoaded: ".ccs-cc-inline-ensure-style-loaded",
		hiddenHrefLinks: "a[data-url]",
		clickableClass: "ccs-cc-inline-clickable",
		urlAttr: "data-url"
	};
	$.extend(c, common);

	function isMobileDevice() {
		return ccs_util.isMobile();
	}

	function isIE() {
		var myNav = navigator.userAgent.toLowerCase();
		return (myNav.indexOf("msie") !== -1) ? parseInt(myNav.split("msie")[1]) : false;
	}

	function restoreHref($container) {
		$container
			.find(c.hiddenHrefLinks)
			.addBack(c.hiddenHrefLinks)
			.each(function () {
				var $link = $(this);
				var url = $link.attr(c.urlAttr);
				$link.attr("href", url).removeAttr(c.urlAttr);
				$link.addClass(c.clickableClass);
			});
	}

	function ensureStyles($container) {
		return $container.find(c.ensureStyleLoaded).height() > 0;
	}

	function bindResizeEvent(func) {

		if (isMobileDevice()) {
			window
				.matchMedia("(orientation: portrait)")
				.addListener(func);
		} else {
			$(window).on("resize", func);
		}
	}

	function isElementInViewport(element, spread) {

		spread = spread || 0;

		var $element = $(element);
		if ($element.length === 0) {
			return false;
		}

		var windowsHeight = $(window).height();
		var viewportScrollTop = $(window).scrollTop();

		var areaTop = viewportScrollTop < spread ? 0 : viewportScrollTop - spread;
		var areaBottom = viewportScrollTop + windowsHeight + spread;

		var elementTop = $element.offset().top;
		var elementBottom = elementTop + $element.height();

		return elementBottom <= areaBottom
				&& elementTop >= areaTop
				&& $element.is(":visible");
	}

	function makeClientParams($item) {
		var clientParams = {};
		var $parentSection = $item.closest("[data-elementid]");

		clientParams.ElementIds = $parentSection.attr("data-elementid");

		var elementContext = $parentSection.attr("data-context");
		if (elementContext)
			clientParams.ElementContext = elementContext;

		return clientParams;
	}

	/**
	 * Client analog of InlineContentEventUtil.MakeActionContext
	 */
	function makeActionContext($item) {
		var mediaType = $item.attr(c.mediaTypeAttr);
		var mediaUrl = (mediaType === "video"
							? $.ccsVideoPlayer.canPlayHls()
								? $item.attr("data-transcoded-video-url") || $item.attr("data-video-url")
								: $item.attr("data-video-url")
							: $item.attr("data-image-url"))
						|| $item.attr("data-fancybox-href")
						|| $item.attr("href");

		if (!mediaType || !mediaUrl || mediaUrl === "javascript:;") {
			if (console && console.error)
				console.error("Can't make action context: media type or an url are invalid.");

			return null;
		}

		return JSON.stringify({ type: mediaType, url: mediaUrl });
	}

	// https://www.w3schools.com/js/js_cookies.asp
	function setCookie(cname, cvalue, exdays) {
		var cookie = cname + "=" + cvalue + ";path=/";
		if (exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

			cookie += ";expires=" + d.toUTCString();
		}
		document.cookie = cookie;
	}
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	// end cookie

	function fixBlockWidth($ep) {
		var $block = $ep,
			timer;

		if ($block.closest("td").length) {
			var fixInvoker = function() {
				if ($block.is(":visible")) {
					$block.css("position", "absolute");

					var width = $block.parent().width();
					if (width !== 0) {
						$block.width(width);
					}

					$block.css("position", "");
				} else {
					clearTimeout(timer);
					timer = setTimeout(fixInvoker, 300);
				}
			};

			bindResizeEvent(fixInvoker);
			fixInvoker.call();
		}
	}

	return {
		isMobileDevice: isMobileDevice,
		isIE: isIE,
		restoreHref: restoreHref,
		ensureStyles: ensureStyles,
		bindResizeEvent: bindResizeEvent,
		isElementInViewport: isElementInViewport,
		makeClientParams: makeClientParams,
		makeActionContext: makeActionContext,
		setCookie: setCookie,
		getCookie: getCookie,
		fixBlockWidth: fixBlockWidth
	};
});

define('ic/video',["jquery", "./utils", "./common"], function ($, utils, common) {

	var c = {
		cartCookie: "ccs_video_cart",
		playerSelector: ".mejs__container",
		buyRootSelector: ".ccs-video-buy",
		buyVisibleClass: "ccs-video-buy-visible",
		cartButtonSuffix: "cart",
		closeButtonSuffix: "close"
	};

	$.extend(c, common);

	function init(element, settings, reinit) {
		var $wrapper = $(element);
		var player = $wrapper.ccsVideoPlayer("getPlayer");

		if (player == null || reinit) {
			player = $wrapper.ccsVideoPlayer(settings);
		}

		return player;
	}

	function initInline(element, /*media*/ o, mute, autoplay, initByAutoplay) {
		var $wrapper = $(element);

		var playerId = $wrapper.data("player");

		var settings = {
			playerId: playerId,
			file: $wrapper.data("video-url"),
			transcodedFile: $wrapper.data("transcoded-video-url"),
			image: $wrapper.data("image-url"),
			ccUrl: $wrapper.data("cc-url"),
			ccLang: $wrapper.data("cc-lang"),
			ccForceOnYouTube: $wrapper.data("cc-force-yt"),
			height: $wrapper.data("media-height") || "100%",
			width: $wrapper.data("media-width") || "100%",
			autoplay: autoplay, // TODO: Consider about renaming of 'autoplay' to autoStart or playOnInit.
			initByAutoplay: !!initByAutoplay,
			mute: mute,
			volume: 80,
			debug: true,
			fancyboxMode: false,
			pluginPath: o.pluginPath,
			tracking: {
				clientParams: utils.makeClientParams($wrapper),
				videoEventData: $wrapper.attr(c.videoLogCallAttr),
				errorEventData: $wrapper.attr(c.errorLogCallAttr)
			}
		};

		return init($wrapper, settings);
	}

	function autoPlayInViewport(ep, o) {
		var $ep = ep;
		var opt = o;

		if (opt.autoPlayVideoInViewPort && !utils.isMobileDevice()) {
			setTimeout(function() {
				$ep.find(c.embeddedVideoSelector).not(c.noAutoplaySelector + " " + c.embeddedVideoSelector).each(function () {
					var $el = $(this);

					var settings = {
						initByAutoplay: true,
						mute: true,
						tracking: {
							clientParams: utils.makeClientParams($el)
						}
					};

					$.ccsVideoPlayer.initAutoPlay(opt, $el, settings);
				});
			}, 1500);
		}
	}

	function addBuyButton(options) {

		var o = options.product;
		if (!o) return;

		var cookieStr = utils.getCookie(c.cartCookie);
		var cookie = cookieStr ? JSON.parse(cookieStr) : {};

		var showOverlay = function (e) {
			$("#" + e.player.playerId)
				.closest(c.playerSelector)
				.find(c.buyRootSelector)
				.addClass(c.buyVisibleClass);
		};
		var stopHandler = function (e) {
			if (e.originalEvent.type === "ended") {
				showOverlay(e);
			}
		};
		$(document).on("ccsPlayer",
			function (e) {
				if (e.originalEvent.type !== "canplay")
					return;

				var $player = $("#" + e.player.playerId).closest(c.playerSelector);

				if ($player.find(c.buyRootSelector).length)
					return;

				var $wrapper = $("<div class='ccs-video-buy'>").appendTo($player);

				var addToCart = $(o.addToCartHtml).children(":first");
				var $cartButton = createButton(addToCart, c.cartButtonSuffix);

				if (!cookie[o.masterId]) {

					var $closeButton = createButton("<a href='javascript:;'>", c.closeButtonSuffix /*, o.closeText*/);
					
					$("<div class='ccs-video-buy-overlay'>")
						.append(
							$("<div class='ccs-video-buy-inner'>").append($cartButton).append($closeButton))
						.appendTo($wrapper);

					$closeButton.add($cartButton)
						.on("click", function () {
							cookie[o.masterId] = 1;
							utils.setCookie(c.cartCookie, JSON.stringify(cookie));

							$(document).off("ccsPlayer", null, stopHandler);

							$wrapper.removeClass(c.buyVisibleClass);
						});

					$(document).on("ccsPlayer", stopHandler);
				}

				var $floatButton = $cartButton.clone().addClass("ccs-video-buy-float").appendTo($wrapper);

				$cartButton.add($floatButton).on("click",
					function () {
						var clientParams = {
							ActionContext: JSON.stringify({
								type: "video-addtocart",
								url: e.player.getSrc(),
								pos: Math.round(e.player.getCurrentPosition())
							})
						};

						var elementId = $(e.target).closest(".ccs-cc-inline-section").data("elementid");
						if (elementId) {
							clientParams.ElementIds = elementId;
						}

						ccs_cc_log.dispatchEvent(o.logCall, clientParams);
					});
			});
	}

	function createButton(html, suffix, text) {
		var buttonClass = "ccs-video-buy-button";

		var $button = $(html);

		if (text) {
			$button.text(text).attr("title", text);
		}

		return $button.addClass(buttonClass + " " + buttonClass + "-" + suffix);
	}

	return {
		init: init,
		initInline: initInline,
		stop: $.ccsVideoPlayer.stopPlayer,
		autoPlayInViewport: autoPlayInViewport,
		addBuyButton: addBuyButton
	};
});
define('ic/swipe',["jquery"], function ($) {
	// jQuery plugin
	// https://github.com/marcandre/detect_swipe

	$.detectSwipe = {
		version: "2.1.2",
		enabled: "ontouchstart" in document.documentElement,
		preventDefault: true,
		threshold: 100
	};

	var startX,
	  startY,
	  isMoving = false;

	function onTouchEnd() {
		this.removeEventListener("touchmove", onTouchMove);
		this.removeEventListener("touchend", onTouchEnd);
		isMoving = false;
	}

	function onTouchMove(e) {
		if ($.detectSwipe.preventDefault) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
		if (isMoving) {
			var x = e.touches[0].pageX;
			var y = e.touches[0].pageY;
			var dx = startX - x;
			var dy = startY - y;
			var dir;
			if (Math.abs(dx) >= $.detectSwipe.threshold) {
				dir = dx > 0 ? "left" : "right";
			}
			else if (Math.abs(dy) >= $.detectSwipe.threshold) {
				dir = dy > 0 ? "up" : "down";
			}
			if (dir) {
				onTouchEnd.call(this);
				$(this).trigger("swipe", dir).trigger("swipe" + dir);
			}
		}
	}

	function onTouchStart(e) {
		if (e.touches.length === 1) {
			startX = e.touches[0].pageX;
			startY = e.touches[0].pageY;
			isMoving = true;
			this.addEventListener("touchmove", onTouchMove, false);
			this.addEventListener("touchend", onTouchEnd, false);
		}
	}

	function setup() {
		this.addEventListener && this.addEventListener("touchstart", onTouchStart, false);
	}

	function teardown() {
		this.removeEventListener("touchstart", onTouchStart);
	}

	$.event.special.swipe = {
		setup: setup,
		teardown: teardown
	};

	$.each(["left", "up", "down", "right"], function () {
		$.event.special["swipe" + this] = {
			setup: function () {
				$(this).on("swipe", $.noop);
			}
		};
	});
});

define('ic/lightbox',["jquery", "./utils", "./video", "./common", "./swipe"], function ($, utils, video, common) {
	var c = {
		playerId: "ccs-cc-videoplayer",
		zoomLogCallAttr: "data-zoom-log-call",
		videoWidth: 600,
		videoHeight: 400,
		fancyboxBorderOffset: 70, // default: margin - 20px, padding - 15px
		smallScreen: 570,
		videoPlayLogAction: "video-play",
		overlaySelector: ".ccs-fancybox-overlay",
		backButtonClass: "ccs-fancybox-back",
		mobileOverlayClass: "ccs-mobile-overlay",
		noScrollClass: "ccs-body-fixed"
	};

	$.extend(c, common);

	/*
		media
			pluginPath
			lightbox
				backButtonText
				enableMobileMode
				poweredByLogoUrl
	*/

	var state = {
		isMobile: utils.isMobileDevice(),
		lightboxIsOpen: false
	};

	function initFancyboxForMedia($mediaElements, o) {
		if (isLightboxEnabled(o.lightbox)) {
			var config = getFancyboxConfig(o);

			$mediaElements.fancybox(config);
		} else {
			$mediaElements.on("click", function () {
				openLinkInNewTab(this, o, this.href);
			});
		}
	}

	function isLightboxEnabled(options) {

		if (!state.isMobile)
			return true;

		return options.enableMobileMode
			? true
			: Math.min($(window).width(), $(window).height()) < c.smallScreen;
	}

	function getFancyboxConfig(o) {
		var player;

		var config = {
			openSpeed: 200,
			closeSpeed: 100,
			nextSpeed: 200,
			prevSpeed: 200,
			minWidth: 1,
			minHeight: 1,
			live: false,
			helpers: {
				overlay: {
					locked: true
				}
			},
			afterLoad: function (current, previous) {
				var $el = $(this.element);
				var isImageType = $el.attr(c.mediaTypeAttr) === "image";

				var logCall = isImageType
					? $el.attr(c.zoomLogCallAttr)
					: $el.attr(c.videoLogCallAttr);
				var clientParams = utils.makeClientParams($el);

				if (previous) {
					submitNavigateEvent($.extend({
						logCall: logCall,
						next: current.index,
						previous: previous.index,
						isRtl: o.isRtl
					}, clientParams));

					if (player && $.isFunction(player.pause)) {
						player.pause();
					}
				}

				if (isImageType) {
					ccs_cc_log.dispatchEvent(logCall, clientParams);
				}
			},
			beforeLoad: function () {
				var $el = this.element;
				var mediaType = $el.attr(c.mediaTypeAttr);

				if (isSmallMobileScreenWidth()) {
					this.helpers.overlay.closeClick = false;
				}

				if (mediaType === "video" || mediaType === "youtube") {
					setPlayerFancyboxContent(o, this);
				}

				$el.trigger("ccsFancyboxBeforeLoad");
			},
			afterShow: function () {
				var mediaType = this.element.attr(c.mediaTypeAttr);
				var clientParams = utils.makeClientParams(this.element);

				$(".fancybox-wrap.ccs-fancybox").find(".fancybox-inner").focus();

				if (mediaType === "video") {
					var $link = this.element;
					var settings = {
						playerId: c.playerId,
						file: this.href,
						transcodedFile: this.element.attr("data-transcoded-video-url"),
						ccUrl: this.element.data("cc-url"),
						ccLang: this.element.data("cc-lang"),
						ccForceOnYouTube: this.element.data("cc-force-yt"),
						fancyboxMode: true,
						type: mediaType,
						height: c.videoHeight > this.inner.height() ? this.inner.height() : c.videoHeight,
						width: "100%",
						enableAutosize: true,
						autoplay: true,
						pluginPath: o.pluginPath,
						tracking: {
							clientParams: clientParams,
							videoEventData: $link.attr(c.videoLogCallAttr),
							errorEventData: $link.attr(c.errorLogCallAttr)
						}
					};

					player = video.init($link, settings, true);
				}
				fancyBoxTabsNavigation(this.wrap);

				if (this.group.length > 1) {
					enableLightboxSwipe(this);
				}

				disableScroll();
				state.lightboxIsOpen = true;
			},
			beforeShow: function () {
				var $el = $(this.element);

				var isSmallScreen = isSmallMobileScreenWidth();

				if ($el.attr(c.mediaTypeAttr) === "image") {

					var alt = this.title || $el.find("img").attr("alt");

					this.inner
						.find("img.fancybox-image")
						.attr("alt", alt);

					if (!isSmallScreen)
						addPoweredByLogo(this.inner, o.lightbox.poweredByLogoUrl);
				}

				if (isSmallScreen)
					enableMobileBehavior(o.lightbox.backButtonText);

				$el.trigger("ccsFancyboxBeforeShow");
			},
			beforeClose: function () {
				if (player && $.isFunction(player.pause))
					player.pause();
			},
			afterClose: function () {
				var $el = $(this.element);

				enableScroll();
				state.lightboxIsOpen = false;

				$el.trigger("ccsFancyboxAfterClose");
			},
			onUpdate: function () {
				if (player && $.isFunction(player.setPlayerSize)) {
					player.setPlayerSize("100%", this.inner.height());
				}
			}
		};

		if (o.isRtl === true) {
			config.tpl = {
				prev: $.fancybox.defaults.tpl.next,
				next: $.fancybox.defaults.tpl.prev
			};
		};

		return config;
	}

	function submitNavigateEvent(params) {
		var direction = params.next - params.previous;
		if (direction === 0)
			return;

		var eventParams = {
			Action: "navigate-content",
			ActionContext: JSON.stringify({
				subelement: "lightbox",
				scroll: direction > 0 ^ params.isRtl ? "right" : "left",
				target: params.next
			}),
			ElementIds: params.ElementIds
		}

		if (params.ElementContext) {
			eventParams.elementContext = params.ElementContext;
		}

		ccs_cc_log.dispatchEvent(params.logCall, eventParams);
	}

	function addPoweredByLogo($element, url) {
		if (!url) return;

		$("<div>")
			.addClass("ccs-cc-inline-poweredby-logo")
			.append($("<img src='" + url + "' alt='' />"))
			.bind("contextMenu", function () { return false; })
			.appendTo($element);
	}

	function isSmallMobileScreenWidth() {
		if (!state.isMobile)
			return false;

		var smallScreenWidth = $(window).width() < c.smallScreen;
		var mobileLightboxIsOpen = $(c.overlaySelector).hasClass(c.mobileOverlayClass);

		if (!mobileLightboxIsOpen && state.lightboxIsOpen)
			return false;

		return mobileLightboxIsOpen || smallScreenWidth;
	}

	function setPlayerFancyboxContent(o, config) {
		config.content = "<div id=\"" + c.playerId + "\"></div>";
		config.width = Math.min($(window).width() - c.fancyboxBorderOffset, c.videoWidth);
		config.height = Math.min($(window).height() - c.fancyboxBorderOffset, c.videoHeight);
		config.padding = [10, 10, 10, 10];
		config.autoHeight = false;
		config.autoWidth = false;
		config.scrolling = "no";
	}

	function fancyBoxTabsNavigation(fancyboxWrapper) {
		var $fancyBoxWrap = $(fancyboxWrapper);
		var $anchorLinks = $fancyBoxWrap.find("a");
		var $iframe = $fancyBoxWrap.find("iframe");
		if ($anchorLinks.length > 0) {
			$anchorLinks.keydown(function (e) {
				if (e.keyCode !== 9)
					return;

				if ($iframe.length > 0) {
					$iframe.focus();
					return;
				}

				if ($anchorLinks.length === 1) {
					$fancyBoxWrap.find(".fancybox-inner").focus();
					e.preventDefault();
					return;
				}

				var $firstAnchor = $fancyBoxWrap.find("a:first");
				var $lastAnchor = $fancyBoxWrap.find("a:last");

				if (e.target === $lastAnchor.get(0) && !e.shiftKey) {
					$firstAnchor.focus();
					e.preventDefault();
				}

				if (e.target === $firstAnchor.get(0) && e.shiftKey) {
					$lastAnchor.focus();
					e.preventDefault();
				}
			});
		}
	}

	function enableLightboxSwipe(o) {
		var $lightboxOverlay = $(c.overlaySelector);

		$(o.inner)
			.add($lightboxOverlay)
			.off("swipeleft swiperight")
			.on("swipeleft swiperight", function (e) {
				e.stopPropagation();
				e.type === "swipeleft" ? $.fancybox.next() : $.fancybox.prev();
			});
	}

	function disableScroll() {
		if ($('meta[name="viewport"]').length === 0 || !state.isMobile)
			return;

		var $body = $("body");
		if ($body.hasClass(c.noScrollClass))
			return;

		var bodyHeight = $body.innerHeight();
		var scrollTop = -$body.scrollTop();

		state.bodyStyle = $body.attr("style");

		$body
			.addClass(c.noScrollClass)
			.css({
				top: scrollTop,
				height: bodyHeight
			});
	}

	function enableScroll() {
		var $body = $("body");
		var scrollTop = parseInt($body.css("top"), 10);

		if (!$body.hasClass(c.noScrollClass))
			return;

		$body.attr("style", state.bodyStyle);

		$body.removeClass(c.noScrollClass);
		window.scrollTo(0, -scrollTop);
	}

	function enableMobileBehavior(backButtonText) {
		if ($("." + c.backButtonClass).length !== 0)
			return;

		var $lightboxOverlay = $(c.overlaySelector);

		$("<a>")
			.addClass(c.backButtonClass)
			.attr("role", "link")
			.text(backButtonText)
			.one("click", function () {
				$.fancybox.close();
			})
			.prependTo($lightboxOverlay);

		$lightboxOverlay.addClass(c.mobileOverlayClass);
	}

	function openLinkInNewTab($link, o, href) {

		if ($link.attr(c.videoLogCallAttr)) {
			ccs_cc_log.dispatchEvent($link.attr(c.videoLogCallAttr), { Action: o.videoPlayLogAction });
		}
		else {
			var clientParams = utils.makeClientParams($link);

			clientParams.ActionContext = utils.makeActionContext($link);

			if (clientParams.ActionContext)
				ccs_cc_log.dispatchEvent($link.attr(c.zoomLogCallAttr), clientParams);
		}

		window.open(href, "_blank");
	}

	$(window).on("orientationchange", function () {
		if ($.fancybox.isActive)
			$.fancybox.reposition();
	});

	return {
		initMedia: initFancyboxForMedia,
		fancyBoxTabsNavigation: fancyBoxTabsNavigation
	};
});
define('ic/gallery/base',["jquery", "./consts", "ic/utils", "ic/lightbox"], function ($, c, utils, lightbox) {

	function BaseGallery($gallery, o, config) {
		var _ = this;

		_.$gallery = $gallery;
		_.$slick = $gallery.find(c.thumbsContainer);

		_.o = o.media;
		_.config = config;
	}

	$.extend(BaseGallery.prototype, {
		init: function () {
			var _ = this,
				config = _.config,
				$slick = _.$slick,
				$gallery = _.$gallery;

			if (utils.isMobileDevice()) {
				$slick
					.children().has("[data-video-url$='.flv']")
					.remove();
			}

			_.updateAttributes();

			var resizeTimer;
			var resizeInvoker = function () {
				clearTimeout(resizeTimer);

				if ($slick.is(":visible")) {
					_.resize();
				} else {
					resizeTimer = setTimeout(resizeInvoker, 500);
				}
			};

			$slick
				.on("init", function (e, slick) {
					_.slick = slick;

					lightbox.initMedia(slick.$slides, _.o);

					$slick.closest(c.rootBlockSelector).on("ccsResize", resizeInvoker);
					utils.bindResizeEvent(resizeInvoker);
					resizeInvoker();
				})
				.on("beforeChange", function (e, slick, previousSlide, nextSlide) {
					_.submitNavigateEvent({
						nextSlide: nextSlide,
						previousSlide: previousSlide
					});
				});

			$(document).on("ccsFancyboxAfterClose", c.slideSelector, function (e) {
				var $slide = $(e.target);

				if (!$slick.has($slide).length)
					return;

				_.switchSlide($slide, true);
			});

			_.beforeInit();

			var slickConfig = $.extend({}, c.slickDefaults, { rtl: _.o.isRtl });
			$slick.ccsSlick(slickConfig);

			_.afterInit();

			$gallery.trigger({ type: "ccsGalleryLoad", gallery: _ });
		},

		updateAttributes: function () {
			var _ = this,
				config = _.config,
				$slides = _.$slick.children();

			var elementId = _.$gallery.closest(c.sectionSelector).attr("id");

			$slides.each(function (index, el) {
				var $slide = $(el).attr(c.fancyboxGroupAttr, elementId);

				switch ($slide.attr(c.mediaTypeAttr)) {
					case "video":
						$slide
							.attr(c.fancyboxTypeAttr, "html")
							.attr(c.fancyboxHrefAttr, $slide.data("video-url"))
							.attr(c.videoLogCallAttr, config.logCall)
							.attr(c.errorLogCallAttr, config.errorLogCall);

						break;

					case "image":
						$slide
							.attr(c.fancyboxTypeAttr, "image")
							.attr(c.fancyboxHrefAttr, $slide.data("image-url"));

						break;
				}

				var $img = $slide.find("img");

				var alt = $img.attr("alt");
				if (!alt) return;

				alt = ccs_util.stringFormat(alt, index + 1, $slides.length);

				$img.attr("alt", alt.toLowerCase());
			});
		},

		submitNavigateEvent: function (params) {
			var direction = params.nextSlide - params.previousSlide;
			if (direction === 0)
				return;

			var actionContext = {
				subelement: params.subelement,
				scroll: direction > 0 ^ params.isRtl ? "right" : "left"
			};

			if (actionContext.subelement) {
				actionContext.target = params.nextSlide;
			}

			ccs_cc_log.dispatchEvent(this.config.logCall, {
				Action: "navigate-content",
				ActionContext: JSON.stringify(actionContext)
			});
		},

		changeSlidesCount: function () {
			var _ = this,
				slick = this.slick;

			var slickSize = slick.$list.width();

			var $slide = slick.$slides.find(".ccs-cc-thumbnail-wrapper:visible");
			var slideSize = $slide.outerWidth(true);

			var slidesCount = _.calcCount(slickSize, slideSize);

			if (slick.options.slidesToShow !== slidesCount || slick.listWidth === 0) {
				_.slickSetSlidesCount(slidesCount);
			}
		},

		calcCount: function (wrapSize, slideSize) {
			return Math.max(Math.floor(wrapSize / slideSize), 1);
		},

		slickSetSlidesCount: function (count) {
			var slick = this.slick;

			slick.slickSetOption("slidesToShow", count);
			slick.slickSetOption("slidesToScroll", count);

			slick.refresh();
		},

		resize: function () { },
		beforeInit: function () { },
		afterInit: function () { },
		switchSlide: function (slide, dontAnimate) { }
	});

	return BaseGallery;
});

define('ic/gallery/ribbon',["jquery", "./consts", "./base"], function ($, c, BaseGallery) {

	function RibbonGallery() {
		BaseGallery.apply(this, arguments);
	}

	RibbonGallery.prototype = Object.create(BaseGallery.prototype);

	$.extend(RibbonGallery.prototype, {
		afterInit: function () {
			var _ = this;
			if (_.o.isRtl)
				_.slick.loadImages();
		},

		resize: function () {
			this.changeSlidesCount();
		},

		switchSlide: function (slide) {
			var $slide = $(slide).closest(".ccs-slick-slide");

			if (!$slide.length)
				return;

			var slickIndex = $slide.data("slick-index");

			this.slick.goTo(slickIndex, true);
			this.slick.loadImages();
		}
	});

	return RibbonGallery;
});

define('ic/gallery/cloud',["jquery", "./consts", "./base", "ic/video", "ic/utils"], function ($, c, BaseGallery, video, utils) {

	function CloudGallery() {
		BaseGallery.apply(this, arguments);
	}

	CloudGallery.prototype = Object.create(BaseGallery.prototype);

	$.extend(CloudGallery.prototype, {

		beforeInit: function () {
			this.$slick
				.find(c.slideSelector)
				.each(function () {
					var $link = $(this).find("a.ccs-cc-thumbnail-wrapper");
					$("<span class='ccs-cc-thumbnail-wrapper'>").html($link.html()).insertAfter($link);
				});
		},

		afterInit: function () {
			var _ = this,
				$slides = _.slick.$slides;

			utils.isMobileDevice()
				? _.initMobileBehavior()
				: _.initDesktopBehavior();

			_.switchSlide($slides.first(), true);
		},

		initMobileBehavior: function () {
			var _ = this,
				$slick = _.$slick,
				$slides = _.slick.$slides,
				$gallery = _.$gallery;

			$slides.find(".ccs-cc-thumbnail-wrapper").on("click", function (e) {
				_.switchSlide(e.target);

				if (e.originalEvent) {
					e.stopImmediatePropagation();
				}
			});

			$gallery.find(c.cloudViewportArrow).remove();

			$gallery.find(".ccs-cc-ig-cloud-viewport")
				.on("swipeleft swiperight", function (e) {
					var $curSlide = $slick.find("." + c.cloudActiveClass);
					var $newSlide = e.type === "swiperight" ? $curSlide.prev() : $curSlide.next();

					if ($newSlide.length) {
						var eventParams = _.createEventParams($newSlide, $curSlide);

						_.submitNavigateEvent(eventParams);
						_.switchSlide($newSlide);
					}
				});
		},

		initDesktopBehavior: function () {
			var _ = this,
				$slides = _.slick.$slides;

			var navOnHoverTimer;
			$slides
				.on("mouseover", function (e) {
					navOnHoverTimer = setTimeout(function () {
						_.switchSlide(e.target);
					}, 100);
				})
				.on("mouseout", function () {
					clearTimeout(navOnHoverTimer);
				});

			_.$gallery.find(c.cloudViewportArrow).on("click", function (e) {
				var $arrow = $(e.target).closest(c.cloudViewportArrow);

				var $curSlide = $slides.filter("." + c.cloudActiveClass);
				var $newSlide = $arrow.is(".ccs-slick-prev") ? $curSlide.prev() : $curSlide.next();

				var eventParams = _.createEventParams($newSlide, $curSlide);

				_.submitNavigateEvent(eventParams);
				_.switchSlide($newSlide);
			});
		},

		resize: function () {
			this.changeHeight();
			this.changeSlidesCount();
		},

		switchSlide: function (slide, isNotInvokedByUser) {
			var _ = this,
				$slick = _.$slick,
				slick = _.slick;

			var $slide = $(slide).closest(c.slideSelector);

			var $prevActive = $slick.find("." + c.cloudActiveClass);

			if ($slide.is($prevActive)) {
				return;
			}

			if (!isNotInvokedByUser) {
				_.submitHoverEvent($slide);
			}

			$prevActive
				.removeClass(c.cloudActiveClass)
				.find("a").removeAttr("disabled");

			$slide
				.addClass(c.cloudActiveClass)
				.find("a").attr("disabled", "");

			var $viewport = $slick.siblings(c.cloudViewport);

			$viewport.toggleClass("first-slide", $slide.is(":first-child"))
					 .toggleClass("last-slide", $slide.is(":last-child"));

			if (_.o.isRtl) {
				slick.loadImages();
			}

			if (!_.slideIsVisible($slide)) {
				slick.goTo($slide.data("slick-index"), isNotInvokedByUser);
				slick.loadImages();
			}

			var $prev = $viewport.children("." + c.cloudActiveClass);
			$prev.removeClass(c.cloudActiveClass);
			video.stop($prev.children());

			var $viewportSlide = $viewport.find("[data-slide-index=" + $slide.index() + "]");

			if ($viewportSlide.length !== 0) {
				$viewportSlide.addClass(c.cloudActiveClass);
			} else {
				$viewport.prepend(
					_.createViewportSlide($slide));
			}
		},

		submitHoverEvent: function ($slide) {
			var clientParams = utils.makeClientParams($slide);

			var eventParams = {
				Action: "hover",
				ActionContext: utils.makeActionContext($slide),
				ElementIds: clientParams.ElementIds
			};

			if (clientParams.ElementContext)
				eventParams.ElementContext = clientParams.ElementContext;

			ccs_cc_log.dispatchEvent(this.config.logCall, eventParams);
		},

		slideIsVisible: function ($slide) {
			var $slick = this.$slick;

			return $slick.offset().left < $slide.offset().left
				&& $slick.offset().left + $slick.width() > $slide.offset().left + $slide.width();
		},

		createViewportSlide: function ($slickSlide) {
			var _ = this;

			var imgUrl = $slickSlide.data("image-url");
			var altText = $slickSlide.find("img").attr("alt").replace(_.o.zoomIn, _.o.showLargeImg);

			var $viewportSlide = $("<div>")
					.addClass("ccs-cc-ig-viewport-slide loading")
					.attr("data-slide-index", $slickSlide.index());

			var $viewportWrapper = $("<a class='ccs-cc-viewport-slide-wrapper' tabindex='-1' href='javascript:;' >");

			var $viewportImage =
					$("<img class='ccs-cc-ig-viewport-preview'>")
						.attr("tabindex", 0)
						.attr("src", imgUrl)
						.attr("alt", altText)
						.on("load", function () {
							$viewportSlide.removeClass("loading");
						});

			var createConcreteSlide = $slickSlide.data("media-type") === "image"
				? _.createImageViewportSlide
				: _.createVideoViewportSlide;

			createConcreteSlide.call(_, $slickSlide, $viewportWrapper, $viewportImage);

			setTimeout(function () {
				$viewportSlide.addClass(c.cloudActiveClass);	// for animation
			}, 10);

			return $viewportSlide.append($viewportWrapper);
		},

		createImageViewportSlide: function ($slickSlide, $viewportWrapper, $viewportImage) {
		
			$viewportWrapper
				.attr(c.mediaTypeAttr, "image")
				.on("click", function () {
					$slickSlide.trigger("click");
				})
				.on("keypress", function (e) {
					if (e.keyCode === 13) {
						$slickSlide.trigger("click");
						return false;
					}
				})
				.append($viewportImage);
		},

		createVideoViewportSlide: function ($slickSlide, $viewportWrapper, $viewportImage) {
			var _ = this;

			var playerId = $slickSlide.closest(c.sectionSelector).attr("id") + "_player-" + $slickSlide.index();

			var $player = $("<div>")
				.attr("id", playerId)
				.append($viewportImage)
				.appendTo($viewportWrapper);

			$viewportImage.on("load", function () {
				$player.append($("<span class='ccs-cc-inline-video-play-icon'>"));
			});

			_.copyDataAttributes($slickSlide, $viewportWrapper);

			var initPlayer = function () {
				video.initInline($viewportWrapper, _.o, false, true);
			};

			$viewportWrapper.attr("data-player", playerId);

			if (utils.isMobileDevice()) {
				setTimeout(initPlayer, 0);
			} else {
				$viewportWrapper
					.on("keydown", function (e) {
						if (e.keyCode === 13) {
							initPlayer();
						}
					})
					.one("click", initPlayer);
			}
		},

		createEventParams: function ($newSlide, $curSlide) {
			return {
				subelement: "cloud",
				nextSlide: $newSlide.index(),
				previousSlide: $curSlide.index()
			};
		},

		copyDataAttributes: function ($source, $target) {
			var attr = $.grep($source[0].attributes, function (at) { return /^data-/.test(at.name); });
			for (var i = 0; i < attr.length; i++) {
				$target.attr(attr[i].name, attr[i].value)
					.data(attr[i].name, attr[i].value);
			}
		},

		changeHeight: function () {
			var _ = this;
			var $viewport = _.$slick.siblings(c.cloudViewport);

			var width = $viewport.width();
			var curHeight = $viewport.height();

			var maxHeight = _.maxHeight;
			if (!maxHeight) {
				maxHeight = _.maxHeight = curHeight;
			}

			var ratio = 16 / 9;

			if (width < maxHeight * ratio) {
				var newHeight = width / ratio;
				if (newHeight <= maxHeight) {
					$viewport.height(newHeight);
				}
			} else if (curHeight !== maxHeight) {
				$viewport.height(maxHeight);
			}
		}
	});

	return CloudGallery;
});

define('ic/gallery/factory',["jquery", "./ribbon", "./cloud"], function ($, Ribbon, Cloud) {

	function GalleryFactory() { }

	$.extend(GalleryFactory.prototype, {
		GalleryClass: Ribbon,

		create: function ($gallery, o) {
			var config = $gallery.data("config");

			switch (config.layout) {
				case "ribbon":
					this.GalleryClass = Ribbon;
					break;

				case "cloud":
					this.GalleryClass = Cloud;
					break;
			}

			return new this.GalleryClass($gallery, o, config);
		}
	});

	return GalleryFactory;
});

define('ic/gallery',["jquery", "./gallery/consts", "./gallery/factory", "ic/utils"], function ($, c, GalleryFactory, utils) {

	function setup(ep, o) {

		var $galleries = ep.find(c.rootGallerySelector);
		if ($galleries.length === 0)
			return;

		var factory = new GalleryFactory();

		$galleries.each(function () {

			(function updateOnVisible(element) {

				var $gallery = $(element);

				if ($gallery.is(":visible") && utils.ensureStyles(ep)) {

					var gallery = factory.create($gallery, o);

					gallery.init();

					$gallery.data("gallery", gallery);

				} else {
					setTimeout(function () { updateOnVisible(element) }, 300);
				}
			})(this);
		});
	}

	return {
		setup: setup
	};
});

define('ic/polyfill',["jquery", "./utils"], function ($, utils) {

	var c = {
		overlay: ".ccs-cc-inline-overlay .ccs-cc-inline-feature",
		description: ".ccs-cc-inline-feature-description"
	};

	//CCSDT-5449, IE10
	function fixOverlay(ep) {
		var ie = utils.isIE();
		if (!ie || ie > 10)
			return;

		$(ep).find(c.overlay + "[data-media=false] " + c.description).css("width", "100%");
		$(ep).find(c.overlay + "[data-media=true]")
			.each(function () {
				var $container = $(this);
				$container.find(".ccs-cc-inline-thumbnail img")
					.one("load", function (e) {
						var containerWidth = $container.width();
						var imgWidth = $(e.target).width();
						var textWidth = ((containerWidth - imgWidth) / containerWidth * 100) + "%";
						
						$container
							.find(c.description)
							.css("width", textWidth);
					})
					.each(function () {
						if (this.complete) {
							$(this).load();
						}
					});
			});
	}

	return {
		fixOverlay: fixOverlay
	}
});

define('ic/featurecarousel',["jquery", "./utils", "./lightbox", "./video", "./common"], function ($, utils, lightbox, video, common) {

	function FeatureCarousel(container, o) {
		var _ = this;

		_.c = {
			carouselWrapperSelector: ".ccs-cc-fc",
			carouselSelector: ".ccs-cc-fc-items",
			activeSlideSelector: ".ccs-slick-active",
			clonedSlideSelector: ".ccs-slick-cloned",
			customControls: ".ccs-cc-fc-custom-controls",
			bgFeatureSelector: ".ccs-cc-inline-feature-background",
			playPauseBtnSelector: ".ccs-cc-fc-play-pause-btn",
			fcArrows: {
				class: "ccs-cc-fc-arrow",
				selector: ".ccs-cc-fc-arrow",
				next: ".ccs-cc-fc-arrow.ccs-slick-next",
				prev: ".ccs-cc-fc-arrow.ccs-slick-prev"
			}
		};
		$.extend(_.c, common);

		_.$container = $(container);
		_.settings = o.carousel;
		_.isRtl = o.isRtl;
		_.init();
	}

	$.extend(FeatureCarousel.prototype, {
		init: function () {
			var _ = this,
				$container = _.$container,
				settings = _.settings;

			var autoplaySpeed = settings.speed;
			var showArrows = !!settings.arrows;
			var showDots = !!settings.points;

			var isAutoplay = _.isAutoplayEnabled();
			var isMobileDevice = utils.isMobileDevice();

			if (isMobileDevice)
				$container.addClass("ccs-cc-fc-mobile");

			_.$slickWrapper = $container.find(_.c.carouselSelector);
			_.$customControls = $container.find(_.c.customControls);

			if (!showDots && !settings.playpause)
				_.$customControls.remove();

			if (!showArrows)
				$container.find(_.c.fcArrows.selector).remove();

			_.$slickWrapper.ccsSlick({
				autoplaySpeed: autoplaySpeed,
				speed: isMobileDevice ? 100 : 500,
				arrows: showArrows,
				dots: showDots,
				slidesToScroll: 1,
				autoplay: isAutoplay,
				lazyLoad: "progressive",
				pauseOnHover: false,
				infinite: true,
				draggable: false,
				rtl: _.isRtl,
				swipe: isMobileDevice,
				appendDots: _.$customControls,
				prevArrow: $container.find(_.c.fcArrows.prev),
				nextArrow: $container.find(_.c.fcArrows.next)
			});

			_.logCall = _.$slickWrapper.data("log-call");
			_.slick = _.$slickWrapper.ccsSlick("getSlick");
			_.currentSlideIndex = _.slick.currentSlide;
			_.initBackGroundVideoAutoPlay(_.$slickWrapper);

			_.$slickWrapper.on("beforeChange", function (e) {
				$(this).find(".ccs-slick-slide").css("visibility", "visible");
				_.currentSlideIndex = _.slick.currentSlide;
				var player = $(this).data("player-instance");
				if (!player)
					return;

				player.pause();
			});

			_.$slickWrapper.on("afterChange", function (e) {
				$(this).find(".ccs-slick-slide:not('.ccs-slick-active')").css("visibility", "hidden");
				var $self = $(this);
				_.initBackGroundVideoAutoPlay($self);
			});

			_.reportingListener();
			_.initPlayPauseBtn();
			_.fancyboxListener(_.$slickWrapper);
			_.hoverListener();

			_.$slickWrapper.on("ccsPlayer", _.c.embeddedVideoSelector, function (e) {
				if (e.originalEvent.type === "canplay" || e.originalEvent.type === "play") {
					_.$slickWrapper.data("player-instance", e.player);

					if (!isAutoplay) {
						return;
					}

					_.$slickWrapper.ccsSlick("pause");
					_.hoverListener(true);
				}

				if (e.originalEvent.type === "pause" || e.originalEvent.type === "ended") {
					_.$slickWrapper.data("player-instance", null);

					if (!isAutoplay) {
						return;
					}

					_.hoverListener();
				}
			});
		},

		fancyboxListener: function ($container) {
			var _ = this;

			if (!_.isAutoplayEnabled()) {
				return;
			}

			$container.on("ccsFancyboxBeforeShow", ".ccs-cc-inline-thumbnail-media", function (e) {
				$container.ccsSlick("pause");
				_.hoverListener(true);
			});

			$container.on("ccsFancyboxAfterClose", ".ccs-cc-inline-thumbnail-media", function (e) {
				$container.ccsSlick("play");
				_.hoverListener();
			});
		},

		hoverListener: function (turnOff) {
			var _ = this,
				$container = _.$container,
				$slickWrapper = _.$slickWrapper;

			if (!_.isAutoplayEnabled()) {
				return;
			}

			if (turnOff) {
				$container.off("mouseleave mouseenter focusin focusout");
				return;	
			}

			$container
				.on("mouseenter focusin", function (e) {
					$slickWrapper.ccsSlick("pause");
				})
				.on("mouseleave focusout", function (e) {
					var event = "play";
					var $targerElement = $(e.relatedTarget);
					if ($targerElement.hasClass("ccs-zoom-tracker") || $targerElement.hasClass("ccs-fancybox-overlay"))
						event = "pause";

					$slickWrapper.ccsSlick(event);
				});
		},

		isAutoplayEnabled: function () {
			var _ = this,
				settings = _.settings;
			return settings.speed && !utils.isMobileDevice();

		},

		reportingListener: function () {
			var _ = this;
			var $container = _.$container;
			var $wrapper = _.$slickWrapper;
			var $arrows = $container.find(_.c.fcArrows.selector);

			$arrows.on("click", function (e) {
				_.submitNavigateEvent("arrows");
			});

			$container.find(".ccs-slick-dots li").on("click", function (e) {
				_.submitNavigateEvent("points");
			});

			$wrapper[0].addEventListener("swipe", function (e) {
				_.submitNavigateEvent("swipe");
			}, true);
		},

		submitNavigateEvent: function (iteraction) {
			var _ = this,
				slick = _.slick,
				curSlide = _.currentSlideIndex,
				logCall = _.logCall;

			var newSlide = slick.currentSlide;
			var eventParams = {
				subelement: "carousel",
				triggeredby: iteraction,
				nextSlide: newSlide + 1,
				previousSlide: curSlide + 1
			};

			var direction = eventParams.nextSlide - eventParams.previousSlide;
			if (direction === 0)
				return;

			var actionContext = {
				subelement: eventParams.subelement,
				triggeredby: eventParams.triggeredby,
				scroll: direction > 0 ^ _.isRtl ? "right" : "left"
			};

			if (actionContext.subelement) {
				actionContext.target = eventParams.nextSlide;
			}

			ccs_cc_log.dispatchEvent(logCall, {
				ActionContext: JSON.stringify(actionContext)
			});
		},

		initPlayPauseBtn: function () {
			var _ = this,
				settings = _.settings,
				$container = _.$container;

			var $customControls = $container.find(_.c.customControls);
			var $btnPlayPause = $customControls.find(_.c.playPauseBtnSelector);

			if (!settings.playpause || !_.isAutoplayEnabled()) {
				$btnPlayPause.remove();
				return;
			}

			var $slickWrapper = $container.find(_.c.carouselSelector);
			$btnPlayPause.on("click", function (e) {
				var $self = $(this);
				if ($self.hasClass("ccs-play")) {
					$self.removeClass("ccs-play").addClass("ccs-pause");
					$self.attr("aria-label", "click to pause");
					$slickWrapper.ccsSlick("play");
					_.submitClickEvent("play");
					_.hoverListener();
				}
				else {
					_.hoverListener(true);
					$self.removeClass("ccs-pause").addClass("ccs-play");
					$self.attr("aria-label", "click to play");
					$slickWrapper.ccsSlick("pause");
					_.submitClickEvent("pause");
				}
			});

		},

		/*CCSDT-6841 - "autoplay won't work in Safari and Chrome if any of parents of video tag have any DOM manipulation*/
		/*the explicit trigger required*/
		initBackGroundVideoAutoPlay: function ($bgContainer) {
			var _ = this;
			if (utils.isMobileDevice())
				return;

			var $bgVideo = $bgContainer.find(_.c.bgFeatureSelector).find("video");
			if ($bgVideo.length === 0)
				return;

			$bgVideo.each(function () {
				if ($(this).closest(_.c.activeSlideSelector).length === 0)
					$(this)[0].pause();
				else
					$(this)[0].play();

				$(this).prop("muted", true);
			});
		},

		submitClickEvent: function (iteraction) {
			var _ = this,
				logCall = _.logCall;

			var actionContext = {
				subelement: "carousel",
				click: iteraction
			};

			ccs_cc_log.dispatchEvent(logCall, {
				ActionContext: JSON.stringify(actionContext)
			});
		},

		getParams: function (eventName, next, prev) {
			return {
				subelement: eventName,
				nextSlide: next,
				previousSlide: prev
			}
		},

		getSlick: function ($container) {
			return $container.ccsSlick("getSlick");
		}
	});

	return FeatureCarousel;
});
define('ic/features',["jquery", "./utils", "./video", "./lightbox", "./polyfill", "./common", "./featurecarousel"], function ($, utils, video, lightbox, ie, common, Carousel) {

	var c = {
		mobilePrintingVideo: ".ccs-cc-mobileprinting-video a",
		carouselWrapperSelector: ".ccs-cc-fc"
	};

	$.extend(c, common);


	function setup(ep, options) {
		var o = $.extend(options.media, options.features);

		var $mediaElements = ep.find(c.imageSelector + "," + c.videoSelector + "," + c.mobilePrintingVideo);
		lightbox.initMedia($mediaElements, o);

		initCarousel(ep, o);
		initFeaturesZoom(ep, o);
		initEmbeddedVideo(ep, o);
		video.autoPlayInViewport(ep, o);
		initFeaturesLazyLoad(ep, o);
		utils.restoreHref(ep.find(c.videoSelector));
		ie.fixOverlay(ep);

		if (utils.isMobileDevice()) {
			var $bg = ep.find(".ccs-cc-inline-feature-background");
			$bg.find("video").remove();
			$bg.find("img").show();
		}

		$(document).on("ccsFancyboxAfterClose", ".ccs-cc-inline-thumbnail a", function (e) {
			$(e.target).focus();
		});
	}

	function initFeaturesZoom(ep, o) {
		var $featureImages = ep.find(c.imageSelector + " img");
		if (!$featureImages.length) {
			return;
		}

		var inlineZoomSettings = getInlineZoomSettings(ep, o);
		if (inlineZoomSettings) {
			ccs_require("zoomsl");
		}

		$featureImages.one("load", function () {
			var $img = $(this);

			if ($img.attr("src") === $img.attr("data-large")
				&& (this.clientWidth * 1.2 > this.naturalWidth || this.naturalWidth < 200)) {

				$img.parent().before($img).remove();
			}

			if (inlineZoomSettings && $img.parent().is("a")) {
				$img.imagezoomsl(inlineZoomSettings);
			}
		});
	}

	function getInlineZoomSettings(ep, o) {
		if (!o.zoom.enabled || utils.isMobileDevice()) {
			return null;
		}

		var $container = $(".ccs-zoom-container");
		if (!$container.length) {
			$container = $("<div>")
				.addClass("ccs-zoom-container")
				.appendTo(document.body);
		}

		var zoomSettings = {
			disablewheel: false,
			magnifycursor: "pointer",
			showstatus: false,
			originalsize: true,
			container: $container,
			viewport: ep,
			classmagnifier: "ccs-zoom-magnifier",
			classcursorshade: "ccs-zoom-cursorshade",
			classstatusdiv: "ccs-zoom-statusdiv",
			classtextdn: "ccs-zoom-textdn",
			classtracker: "ccs-zoom-tracker",
			onShow: function (e) {
				var $link = e.$img.parent("[" + c.hoverLogCallAttr + "]");
				var clientParams = utils.makeClientParams($link);

				clientParams.ActionContext = utils.makeActionContext($link);
				if (!clientParams.ActionContext)
					return;

				ccs_cc_log.dispatchEvent($link.attr(c.hoverLogCallAttr), clientParams);
			}
		};

		if ($.isNumeric(o.zoom.width) && $.isNumeric(o.zoom.height)) {
			zoomSettings.magnifiersize = [o.zoom.width, o.zoom.height];
		}

		return zoomSettings;
	}

	function initFeaturesLazyLoad(ep, o) {
		var lazyLoadImages = ep.find(c.imageSelector);

		if (lazyLoadImages.length === 0)
			return;

		var startImagesLoading = function () {
			for (var i = lazyLoadImages.length - 1; i >= 0; i--) {
				var $img = $(lazyLoadImages[i]).find("img");

				if (o.disableLazyLoad || utils.isElementInViewport($img, 500)) {
					var src = $img.data("src");

					$img.attr("src", src)
						.removeAttr("data-src")
						.one("load", function (e) {
							utils.restoreHref($(e.target).closest(c.imageSelector));
						});

					if ($img[0].complete) {
						$img.load();
					}
					
					lazyLoadImages.splice(i, 1);
				}
			}

			if (lazyLoadImages.length === 0) {
				window.removeEventListener("scroll", startImagesLoading, true);
				window.removeEventListener("resize", startImagesLoading, true);
			}
		}

		var isVisible = function () {
			if (ep.is(":visible")) {
				startImagesLoading();
				window.addEventListener("scroll", startImagesLoading, true);
				window.addEventListener("resize", startImagesLoading, true);
			} else {
				setTimeout(isVisible, 300);
			}
		};

		setTimeout(isVisible, 100); //wait the content loading for the correct calculation of the target area
	}

	function initEmbeddedVideo(ep, o) {

		ep.find(c.embeddedVideoSelector).each(function () {
			var $wrapper = $(this);

			/*hot-fix for featurecarousel. Do not init cloned videos that uses for infinite loop*/
			if ($wrapper.closest(".ccs-slick-cloned").length !== 0)
				return;

			if (utils.isMobileDevice() && $wrapper.is("[data-video-url$='.flv']")) {
				$wrapper.html(function () {
					return $(this).find("img");
				});
				return;
			}

			$wrapper
				.one("click.initInlineVideo", function () {
					var playerId = $wrapper.data("player");
					if (!$("#" + playerId).length) {
						$wrapper.append(
							$("<div class='ccs-cc-inline-embedded-video-wrapper'>").append(
								$("<video>").attr("id", $wrapper.data("player"))));
					}

					$wrapper
						.removeAttr("tabindex")
						.off("keypress.initInlineVideo");

					video.initInline($wrapper, o);
				})
				.on("keypress.initInlineVideo", function (e) {
					if (e.keyCode === 13) {
						$wrapper.trigger("click.initInlineVideo");
					}
				});

			if (utils.isMobileDevice()) {
				var $img = $wrapper.find("img");

				$img.one("load", function () {
					$wrapper.trigger("click.initInlineVideo");
				});

				if ($img[0].complete) {
					$img.load();
				}
			}
		});
	}

	function initCarousel(ep, o) {
		ep.find(c.carouselWrapperSelector).each((i, item) =>
			$(item).is(":visible")
			? new Carousel(item, o)
			: $(item).closest(".ccs-cc-inline-section").one("accordionOpen", () => new Carousel(item, o))
		);
	}

	return {
		setup: setup
	}
});

define('ic/specs',[], function () {

	var c = {
		specsArea: ".ccs-cc-inline-specifications",
		showButton: ".ccs-cc-inline-specs-more-btn[data-ccs-cc-inline-specs-show]",
		hideButton: ".ccs-cc-inline-specs-more-btn[data-ccs-cc-inline-specs-hide]",
		expandableSpecs: "[data-ccs-cc-inline-specs-expandable]"
	};

	function setup(ep) {

		var $specsArea = ep.find(c.specsArea);
		var $specsShowButton = $specsArea.find(c.showButton);
		var $specsHideButton = $specsArea.find(c.hideButton);
		var $expandableSpecs = $specsArea.find(c.expandableSpecs);

		$specsHideButton.find("a").click(function () {
			$expandableSpecs.hide("fast");
			$specsShowButton.show();
			$specsHideButton.hide();
		});

		$specsShowButton.find("a").click(function () {
			$expandableSpecs.show("fast");
			$specsShowButton.hide();
			$specsHideButton.show();
		});
	}

	return {
		setup: setup
	}
});

define('ic/accordion',["jquery"], function ($) {

	var c = {
		headerSelector: ".ccs-cc-inline-acc-header",
		contentSelector: ".ccs-cc-inline-acc-content",
		stateAttr: "data-ccs-cc-inline-acc-state",
		expanded: "expanded",
		collapsed: "collapsed"
	};

	/* 
		accordion:
			expandedText
			collapsedText
			logCall
	*/

	function setup($container, options) {
		var o = options.accordion;

		$container.find(c.headerSelector).each(function () {
			var $header = $(this);

			changeState($header, o, false, $header.attr(c.stateAttr) === c.expanded);
		});

		$container.on("click",
			c.headerSelector,
			function (e) {
				changeState($(this), o, e.originalEvent !== undefined);
				e.stopPropagation();
			}
		);
	}

	function changeState($header, o, withAnimation, expand) {

		var initialState;

		if (expand === undefined) { // not initialization
			initialState = $header.attr(c.stateAttr);
			expand = initialState !== c.expanded;
		}

		var targetState = expand ? c.expanded : c.collapsed;

		if (initialState === targetState) {
			return;
		}

		$header
			.attr(c.stateAttr, targetState)
			.attr("aria-label", $header.attr("title") + " " + (expand ? o.expandedText : o.collapsedText));

		var $content = $header.parent().parent().children(c.contentSelector);

		if (expand) {
			withAnimation ? $content.slideDown() : $content.css("display", "block");
			$content.trigger("accordionOpen");
		}
		else {
			withAnimation ? $content.slideUp() : $content.css("display", "none");
			$content.trigger("accordionClose");
		}

		if (initialState === undefined) {
			return;
		}

		var context = {
			type: "section-" + (targetState === c.expanded ? "open" : "close")
		}

		var index = $header.data("index");
		if (index) {
			context.index = index;
			context.title = $header.attr("title");
		}

		ccs_cc_log.dispatchEvent(o.logCall,
			{
				ElementIds: $header.closest(".ccs-cc-inline-section").data("elementid"),
				ActionContext: JSON.stringify(context)
			});
	}


	function expand($area) {
		toggle($area, c.expanded);
	}

	function collapse($area) {
		toggle($area, c.collapsed);
	}

	function toggle($area, state) {
		var $header = $area.filter(c.headerSelector).add($area.find(c.headerSelector));

		if ($header.length > 0 && $header.attr(c.stateAttr) !== state) {
			$header.trigger("click");
		}
	}

	return {
		setup: setup,
		expand: expand,
		collapse: collapse
	};
});
define('ic/footnotes',["jquery", "./accordion"], function ($, accordion) {

	var c = {
		linkClass: "ccs-cc-inline-footnote-link",
		headerSelector: ".ccs-cc-inline-footer .ccs-cc-inline-acc-header",
		footnoteIdAttr: "data-ccs-note-id",
		offScreenTextClass: "ccs-off-screen"
	};

	/* 
		footer:
			anchorOffScreenText
	*/

	function setup(ep, options) {

		var o = options.footer;

		var footnoteIdSelector = "[" + c.footnoteIdAttr + "]";

		ep.find(footnoteIdSelector).each(function () {
			var $footnote = $(this);

			var $footnoteAnchors = $footnote.find("a");

			$footnoteAnchors.length > 0
				? updateLink(o, ep, $footnoteAnchors)
				: createNewLink(ep, $footnote);
		});

		var footnoteLinkSelector = "." + c.linkClass;

		ep.on("click",
			footnoteLinkSelector,
			function () {
				var $footerHeader = ep.find(c.headerSelector);
				accordion.expand($footerHeader);
			}
		);
	}

	function updateLink(o, ep, $footnoteAnchors) {
		$footnoteAnchors.each(function () {
			var $footNote = $(this);
			var icId = options.inlineContentId;

			var id = $footNote.attr("id");
			var refId = $footNote.attr("href");

			$footNote
				.attr("id", id + icId)
				.attr("href", refId + icId);

			var $link = ep.find("a[id='" + refId.substring(1) + "']");

			if ($link) {
				$link
					.attr("id", $link.attr("id") + icId)
					.attr("href", $link.attr("href") + icId);
			}

			$footNote
				.prepend(
					$("<span/>").addClass(c.offScreenTextClass).text(o.anchorOffScreenText));
		});
	}

	function createNewLink(ep, $footnote) {
		var noteId = $footnote.attr(c.footnoteIdAttr);

		var $footerLink;

		ep.find("sup")
			.each(function () {
				var $footnoteLinkCandidate = $(this);
				var text = $.trim($footnoteLinkCandidate.text());
				if (text !== noteId || $footnoteLinkCandidate.attr(c.footnoteIdAttr))
					return;

				var $contentLink = createContentLink(noteId);
		
				if (!$footerLink)
					$footerLink = createFooterLink(noteId);

				$footnoteLinkCandidate.html($contentLink).addClass(c.linkClass);
		});

		if (!$footerLink)
			$footerLink = $("<a/>").attr("href", "javascript:;").prepend(noteId);
		var $offScreen = $footnote.find("." + c.offScreenTextClass).detach();
		$footerLink.prepend($offScreen);
		$footnote.html($footerLink);
		$footnote.removeAttr("tabindex");
	}

	function createContentLink(noteId) {
		return createCrossLink(noteId, false);
	};

	function createFooterLink(noteId) {
		return createCrossLink(noteId, true);
	};

	function createCrossLink(noteId, isFooterLink) {
		var prefix = "ccs-f" + options.inlineContentId;

		return $("<a/>")
			.attr("id", prefix + (isFooterLink ? "t" : "") + noteId)
			.attr("href", "#" + prefix + (isFooterLink ? "" : "t") + noteId)
			.text(noteId);
	};

	return {
		setup: setup
	};
});

define('ic/bazaar',["jquery", "./lightbox"], function ($, lightbox) {

	var c = {
		readMoreReviews: "a[data-ccs-read-more-reviews]"
	};

	function setup(ep) {

		ep.find(c.readMoreReviews)
			.fancybox({
				autoSize: false,
				beforeLoad: function () {
					this.width = parseInt(this.element.data("fancybox-width"));
					this.height = parseInt(this.element.data("fancybox-height"));
				},
				afterClose: function () {
					var $target = $(this.element);

					if ($target.length !== 0)
						$target.focus();
					else
						$target.focus();
				},
				afterShow: function () {
					lightbox.fancyBoxTabsNavigation(this.wrap);
				}
			});
	}

	return {
		setup: setup
	}
});

define('ic/jumplinks',["jquery", "./accordion"], function ($, accordion) {

	var c = {
		areaSelector: "div[data-ccs-cc-inline-jumplink]",
		anchorIdAttr: "data-anchor-id",
		holderSelector: "[data-ccs-jumplink-container]",
		itemClass: "ccs-cc-inline-jumplink-item",
		separatorClass: "ccs-cc-inline-jumplink-separator",
		containerClass: "ccs-cc-inline-jumplink-container",
		textAttr: "data-ccs-cc-inline-jumplink",
		hiddenAttr: "data-ccs-jumplink-hidden"
	};

	/*
		jumplinks:
			description: "Jump to: (hard code)",
			enabled: "this param must be received from server."
	*/

	function setup(ep, options) {
		var o = options.jumplinks;

		if (!o.enabled)
			return;

		var jumplinksHtml = o.description;

		ep.find(c.areaSelector).each(function () {
			var $jumplinkArea = $(this);

			var text = $jumplinkArea.attr(c.textAttr);
			var anchorId = $jumplinkArea.attr("id");

			if (!text || !anchorId) return;

			if (jumplinksHtml !== o.description) {
				jumplinksHtml += "<span class='" + c.separatorClass + "'>|</span>";
			}

			jumplinksHtml += $("<a></a>")
				.addClass(c.itemClass)
				.attr("href", "#" + anchorId)
				.attr(c.anchorIdAttr, anchorId)
				.attr("title", text)
				.text(text)
				.wrap("<div></div>")
				.parent()
				.html();
		});

		jumplinksHtml = "<span class='" + c.containerClass + "'>" + jumplinksHtml + "</span>";

		ep.find(c.areaSelector).each(function () {
			var $jumplinkArea = $(this);

			if (!$jumplinkArea.attr(c.hiddenAttr)) {
				$jumplinkArea.find(c.holderSelector).append(jumplinksHtml);

				var anchorId = $jumplinkArea.attr("id");
				var $currentJumplinkItem = $jumplinkArea.find("a[" + c.anchorIdAttr + "='" + anchorId + "']");
				$currentJumplinkItem.prev("." + c.separatorClass).remove();
				$currentJumplinkItem.remove();
			}
		});

		ep.on(
			"click",
			"." + c.itemClass,
			function (event) {
				var areaSelector = "#" + $(event.currentTarget).attr(c.anchorIdAttr);
				var $area = $(areaSelector);

				accordion.expand($area);
			}
		);
	}

	return {
		setup: setup
	}
});

define('ic/mobileimages',["jquery", "./common"], function ($, common) {

	var c = {
		imageModeAttr: "data-image-mode",
		headerImageSelector: ".ccs-cc-inline-header-layout img"
	};

	$.extend(c, common);

	/**
	 * Initializes mobile images swap
	 */
	function setup(ep, options) {
		var trackedImages = ep.find(c.headerImageSelector + ',' + c.imageSelector + " img").get();
		var bpCheck = new RegExp("\\b" + options.media.swapBreakpoint + "px");

		var isDesktopMode = function () {
			var breakpoints = ep.attr("max-width");
			return !breakpoints || !breakpoints.match(bpCheck);
		}

		$(ep).on("ccsBreakpointFired", function () {
			swapImages(trackedImages, isDesktopMode() ? "desktop" : "mobile");
		})
		.trigger("ccsBreakpointFired");

		// header image is hidden to avoid flickering
		var $headerImage = $(c.headerImageSelector);
		if (isDesktopMode()) {
			$headerImage.css('visibility', 'visible');
		} else {
			$headerImage.on('load', function() {
				$(this).css('visibility', 'visible');
			});

			if ($headerImage.length && $headerImage[0].complete)
				$headerImage.load();
		}
	}

	/**
	 * Swaps desktop and mobile images
	 */
	function swapImages(images, mode) {

		for (var i = images.length - 1; i >= 0; i--) {
			var $img = $(images[i]),
				$a = $img.parent(c.imageSelector);

			if (!hasMobileMode($img)) {
				images.splice(i, 1);
				continue;
	}

			if (!changeMode($img, mode))
				continue;

			var actualSrc = pickAttribute($img, "data-src", "src");
			swapAttributes($img, actualSrc, "data-alternative-src");

			var altValue = swapAttributes($img, "data-large", "data-alternative-large");
			if (altValue && $a.length) {
				actualSrc = pickAttribute($a, "data-url", "href");
				$a.attr(actualSrc, altValue);
	}
}
}

	/**
	 * Checks whether the moblie mode is applicable
	 */
	function hasMobileMode($baseNode) {
		return $baseNode.length && $baseNode[0].hasAttribute(c.imageModeAttr);
}

	/**
	 * Changes the mode: mobile|desktop 
	 */
	function changeMode($baseNode, mode) {
		if ($baseNode.attr(c.imageModeAttr) === mode)
			return false;

		$baseNode.attr(c.imageModeAttr, mode);
		return true;
}

	/**
	 * Picks existing attribute
	 */
	function pickAttribute($element, attr, fallbackAttr) {
		return $element[0].hasAttribute(attr)
			? attr
			: fallbackAttr;
}

	/**
	 * Swaps values of attributes
	 * @returns value of alternative attribute
	 */
	function swapAttributes($element, attr, altAttr) {
		var altAttrValue = $element.attr(altAttr);
		if (!altAttrValue)
			return null;

		$element.attr(altAttr, $element.attr(attr));
		$element.attr(attr, altAttrValue);
		return altAttrValue;
}

return {
		setup: setup
	}
});
define('sandisk/capacity',["jquery", "ic/utils"], function ($, utils) {

	var c = {
		rootSelector: ".ccs-cc-inline-capacitychart",
		containerSelector: ".ccs-cc-inline-capacitychart-container",
		contentSelector: ".ccs-cc-inline-acc-content",
		ensureStyleLoaded: ".ccs-cc-inline-ensure-style-loaded",
		widthBoundaryMedium: 570,
		widthBoundaryWide: 680
	};

	var currentColumnCount;

	function init($ep, options) {
		var $chart = $ep.find(c.rootSelector);

		if (!$chart.length)
			return;

		if ($chart.is(":visible") && utils.ensureStyles($ep)) {
			initImpl($chart, options);
		} else {
			setTimeout(function () { init($ep, options); }, 300);
		}
	};

	function initImpl($chart, options) {
		var $container = $chart.find(c.containerSelector);

		var isRtl = options.media.isRtl;

		$container.ccsSlick({
			infinite: false,
			dots: false,
			slidesToScroll: 1,
			speed: 100,
			rtl: isRtl,
			swipeToSlide: !isRtl
		});

		var slick = $container.ccsSlick("getSlick");

		$(window).on("resize", function () {
			refreshSlick($chart, $container, slick);
		});

		var $chartContent = $chart.find(c.contentSelector);

		if ($chartContent.length === 0)
			$chartContent = $chart;

		var isVisible = function () {
			if ($chartContent.is(":visible")) {
				refreshSlick($chart, $container, slick);
			} else {
				setTimeout(isVisible, 300);
			}
		};

		setTimeout(isVisible, 100);
	}

	function refreshSlick($chart, $container, slick) {
		var targetColumnCount = getTargetColumnCount($chart.outerWidth(true));
		if (currentColumnCount === targetColumnCount)
			return;

		currentColumnCount = targetColumnCount;
		var columnCount = $container.data("columns-count");
		if (!columnCount) {
			columnCount = Number.POSITIVE_INFINITY;
		}

		// Delayed update since IE sometimes picks width of pre-resized container.
		setTimeout(function () {
			var count = Math.min(targetColumnCount, columnCount);
			slick.slickSetOption("slidesToShow", count, true);
			$container.toggleClass("ccs-slick-slider-arrows", count < slick.slideCount);
		}, 50);
	}

	function getTargetColumnCount(width) {
		if (width <= c.widthBoundaryMedium) {
			return 3;
		}

		if (width <= c.widthBoundaryWide) {
			return 4;
		}

		return 5;
	};

	return {
		setup: init
	};
});
 define('sandisk/range',["jquery", "ic/utils"], function ($, utils) {
	var c = {
		rootSelector: ".ccs-cc-inline-rangechart",
		tabSelector: ".ccs-cc-inline-rangechart-section-title",
		sectionActiveClass: "ccs-rangechart-section-active",
		contentsSelector: ".ccs-cc-inline-rangechart-section-content"
	};

	function init(ep) {
		var $chart = ep.find(c.rootSelector);

		if (!$chart.length)
			return;

		$chart.on("click", c.tabSelector, function () {
			$(this).closest("[data-section-id]").toggleClass(c.sectionActiveClass);
		});

		if (utils.isMobileDevice()) {
			$chart.on("click", c.tabSelector, function() {
				var $el = $(this).closest("[data-section-id]");

				returnScrollToTitle($el);
			});
		}
	}

	function returnScrollToTitle($el) {
		$("html, body").animate({
			scrollTop: $el.offset().top
		}, 500);
	}

	return {
		setup: init
	};
});
define('sandisk/charts',["jquery", "./capacity", "./range"], function ($, capacity, range) {
	function setup(ep, options) {
		capacity.setup(ep, options);
		range.setup(ep, options);
	}

	return {
		setup: setup
	}
});
define('ic/comparisontable',["jquery"], function ($) {
	var defaults = {
		tableId: "from server"
	};

	function setup(options) {
		if (typeof options.comparisonTable === "undefined")
			return;

		var o = $.extend(true, {}, defaults, options.comparisonTable);
		this.o = o;
		this.table = $("#" + o.tableId);

		var $table = this.table;

		var self = this;

		(function onVisible() {
			if ($table.is(":visible")) {
				updateRowsHeight.call(self);
			} else {
				setTimeout(onVisible, 100);
			}
		}());

		if (window.CcsLogoProgram) {
			window.CcsLogoProgram.detectFeatures(this.o.tableId);
		}

		initCells($table);
	}

	function updateRowsHeight() {
		this.table.find("tr").each(function() {
			var $row = $(this);
			var $titleCell = $row.find("td:first");

			var $img = $titleCell.find("img");

			if ($img.length > 0) {
				$img.on("load", function() {
					setRowHeight($titleCell, $row);
				}).each(function() {
					if (this.complete)
						$(this).load();
				});
			} else {
				setRowHeight($titleCell, $row);
			}
		});
	}

	function setRowHeight($titleCell, $row) {
		var paddingTop = parseInt($titleCell.css("paddingTop"));
		var paddingBottom = parseInt($titleCell.css("paddingBottom"));
		var cellHeight = $titleCell.height();

		var titleCellHeight = cellHeight + paddingTop + paddingBottom;

		$("<td style=\"padding: 0; height: " + titleCellHeight + "px;\"></td>").appendTo($row);
	}

	function initCells($table) {
		$table
			.find(".ccs-cc-comparison-table-cell-content")
			.each(function() {
				var $cell = $(this);
				var initScript = $cell.attr("data-cell-init-script");
				if (initScript) {
					eval(initScript);
				}
			});
	}

	return {
		setup: setup
	}
});


define('ic/compatibleitems',["jquery"], function ($) {

	var c = {
		compatibleItemsSelector: ".ccs-cc-inline-section.ccs-cc-inline-compatibleitems",
		compatibleItemsExpandLinkSelector: ".ccs-cc-inline-compatibleitems-expand-link"
	};

	function setup(ep) {
		var $compatibleItems = ep.find(c.compatibleItemsSelector);

		var $compatibleItemsExpandLink = $compatibleItems.find(c.compatibleItemsExpandLinkSelector);

		$compatibleItemsExpandLink.on("click", function () {
			if (!$compatibleItems.hasClass("ccs-cc-inline-compatibleitems-expanded")) {
				$compatibleItems.addClass("ccs-cc-inline-compatibleitems-expanded");
			}
		});
	}

	return {
		setup: setup
	}
});

define('ic/faq',["jquery", "./accordion"], function ($, accordion) {

	var c = {
		faqSectionSelector: ".ccs-cc-inline-faq .ccs-cc-inline-features",
		stateAttr: "data-ccs-cc-inline-acc-state",
		expanded: "expanded",
		collapsed: "collapsed",
		sectionWithVideo: ".ccs-cc-inline-faq-item:has(.ccs-cc-inline-embedded-video)",
		sectionHeader: ".ccs-cc-inline-acc-header",
		sectionContent: ".ccs-cc-inline-acc-content"
	};

	function setup(ep, options) {
		var $faq = ep.find(c.faqSectionSelector);
		accordion.setup($faq, options);
		initPlayPauseVideo($faq);
	}

	function initPlayPauseVideo($faq) {
		var $videoSections = $faq.find(c.sectionWithVideo);

		$videoSections.on("click", c.sectionHeader, function (e) {
			if ($(e.currentTarget).attr(c.stateAttr) === c.collapsed)
				return;

			var $content = $(e.delegateTarget).find(c.sectionContent);
			var $playerContainer = $content.find("div[data-player]");
			var player = $playerContainer.ccsVideoPlayer("getPlayer");
			if (player == null)
				return;

			player.pause();
		});
	}

	return {
		setup: setup
	}
});
define("jquery", [],function () { return ccsJq; });

define(
	'ic/base',["jquery", "./gallery", "./features", "./specs", "./footnotes", "./bazaar", "./utils", "./accordion", "./jumplinks", "./mobileimages", "./video", "sandisk/charts", "./comparisontable", "./compatibleitems", "./faq"],
	function ($, gallery, features, specs, footnotes, bazaar, utils, accordion, jumplinks, mobileImages, video, sandisk, comparisontable, compatibleitems, faq) {

		function removeProductShowcaseOnMobile(ep) {
			if (utils.isMobileDevice()) {
				ep.find(".ccs-cc-inline-showcase").remove();
			}
		}

		function initDocumentsReporting(ep, o) {
			var $section = ep.find(".ccs-cc-inline-assets");

			$section
				.on("click", ".ccs-cc-inline-asset a",
				function () {
					ccs_cc_log.dispatchEvent(o.logCall, {
						ElementIds: $section.data("elementid"),
						Action: "download",
						ActionContext: $(this).attr("href")
					});
				});
		}

		function initSectionViewportReporting(ep, o) {
		var sectionViewports = ep.find(".ccs-cc-inline-section[data-elementid]")
			.map(function (i, el) {
				var $acc = $(el).find(".ccs-cc-inline-acc-content");
				return $acc.length > 0 ? $acc[0] : el;
			}).toArray();

		ccs_util.initViewportEvent(sectionViewports,
			function () {
				var $section = $(this).closest("[data-elementid]");

					var clientParams = { ElementIds: $section.data("elementid") };

					var context = $section.attr("data-context");
					if (context) {
						clientParams["ElementContext"] = context;
					}

					ccs_cc_log.dispatchEvent(o.viewportLogCall, clientParams);
				});
		}

		function hotfixHeader(ep) {
			var $header = ep.find(".ccs-cc-inline-header .ccs-cc-inline-section-title");
			$header.html($header.text());
		}

		function setup(options) {
			var ep = $("#" + options.inlineContentId);

			hotfixHeader(ep);

			removeProductShowcaseOnMobile(ep);

			gallery.setup(ep, options);
			specs.setup(ep, options);
			footnotes.setup(ep, options);
			bazaar.setup(ep, options);
			features.setup(ep, options);
			mobileImages.setup(ep, options);
			comparisontable.setup(options);

			sandisk.setup(ep, options);

			jumplinks.setup(ep, options);
			accordion.setup(ep, options);
			video.addBuyButton(options);
			compatibleitems.setup(ep);
			faq.setup(ep, options);

			initDocumentsReporting(ep, options);
			initSectionViewportReporting(ep, options);

			utils.fixBlockWidth(ep);
		}

		return {
			setup: setup
		}
	});

define('ic/spin',["jquery"], function ($) {

	var c = {
		width: 480,
		height: 320,
		animate: !ccs_util.isMobile(),
		rootSelector: ".ccs-cc-inline",
		preloadLayer: "div[data-preload-layer='true']",
		preloadContainer: "div[data-preload-container]",
		toolbox: {
			playPauseBtn: "span[data-play-pause='true']",
			defaultSliderHeight: 50,
			slider: "div[data-slider-ui=true]",
			attr: {
				slider: "data-slider-ui"
			},
			css: {
				play: "ccs-cc-inline-video-play-icon",
				pause: "ccs-cc-inline-video-pause-icon"
			}
		}
	}


	function setup(options) {
		var o = $.extend({}, c, options.spritespin);

		var source = o.source;
		if (!source || !source.length)
			return;

		ccs_require("jqSpitespin");
		ccs_require("jqSlider");

		var width = o.width;
		var height = o.height;

		var $toolbox = $("#" + o.toolboxId);
		var $rootDiv = $toolbox.closest(c.rootSelector);
		var $preloadContainer = $rootDiv.find(o.preloadContainer);
		var $playPauseBtn = $toolbox.find(o.toolbox.playPauseBtn);
		var defaultWidth = width;
		var defaultHeight = height;

		var resizeTimeout;

		calculateImageDimensions($preloadContainer, source[0], function (calculatedWidth, calculatedHeight) {
			if (defaultWidth > calculatedWidth)
				defaultWidth = calculatedWidth;

			defaultHeight = calculateContainerHeight(defaultWidth, calculatedWidth, calculatedHeight);

			$(window).resize(function () {
				resizeTimeout = setTimeout(function() {
					onWindowResize.call(o, defaultWidth, defaultHeight, $rootDiv, $toolbox, $playPauseBtn);
				}, 100);
			});

			var api = onWindowResize.call(o, defaultWidth, defaultHeight, $rootDiv, $toolbox, $playPauseBtn, true);

			drawHelperTools.call(o, $toolbox, defaultWidth, $playPauseBtn, api);
		});
	}

	function calculateImageDimensions($preloadContainer, imgUrl, completeCallback) {
		var image = new Image();
		image.src = imgUrl;
		image.onload = function () {
			var calculatedWidth = this.width;
			var calculatedHeight = this.height;

			if ($.isFunction(completeCallback))
				completeCallback(calculatedWidth, calculatedHeight);
		};
	}

	function calculateContainerHeight(containerWidth, imageWidth, imageHeight) {
		return (containerWidth * imageHeight) / imageWidth;
	}

	function drawHelperTools($toolbox, width, $playPauseBtn, spriteSpinApi) {
		var settings = this;

		$toolbox.width(width);

		$playPauseBtn.click(function () {
			settings.animate = changePlayPauseState(
				$playPauseBtn,
				spriteSpinApi,
				settings.animate,
				settings.toolbox.css.pause);

			logChangeState(settings);
		});
	}

	function changePlayPauseState($playPauseBtn, api, isPlaying, cssSelector) {
		if (isPlaying) {
			$playPauseBtn.removeClass(cssSelector);
			api.stopAnimation();
		} else {
			$playPauseBtn.addClass(cssSelector);
			api.startAnimation();
		}

		return !isPlaying;
	}

	function resizeToolbox($toolbox, width) {
		$toolbox.width(width);
	}

	function initControl(width, height, $toolbox, $playPauseBtn, firstTime) {
		var settings = this;

		var id = settings.id;
		var source = settings.source;
		var animate = settings.animate;
		var fps = settings.fps;
		var rate = settings.rate;

		var $spritespinDiv = $("#" + id);
		var $spritespinContainer = $spritespinDiv.parent();
		var $slider;
		var $preloadDiv = $spritespinContainer.find(settings.preloadLayer);
		$preloadDiv.width(width);
		$preloadDiv.height(height + settings.toolbox.defaultSliderHeight);

		var animated = animate;
		var api;

		var rateFramesCount = fps * rate;
		var rateCounter = 0;
		var frameTime = 1000 / fps;

		$spritespinContainer.width(width);
		$spritespinDiv.spritespin({
			animate: animated,
			source: source,
			frames: source.length,
			framesX: 1,
			frameTime: frameTime,
			renderer: "image",
			width: width,
			height: height,
			reverse: false,
			onLoad: function () {

				$preloadDiv.remove();
				api = $spritespinDiv.spritespin("api");
				$slider = $toolbox.find(settings.toolbox.slider);

				if ($slider.length !== 0)
					return;

				$slider = $("<div>");
				$slider.attr(settings.toolbox.attr.slider, "true");

				$slider.slider({
					min: 0,
					max: settings.source.length - 1,
					slide: function (e, ui) {
						if (settings.animate)
							settings.animate = changePlayPauseState(
								$playPauseBtn,
								api,
								settings.animate,
								settings.toolbox.css.pause);

						rateCounter = 0;

						api.updateFrame(ui.value);
					},
					stop: function (e, ui) {
						logRotate(settings, "slider");
					}
				});

				$slider.appendTo($toolbox);

				resizeToolbox($toolbox, width);

				$spritespinDiv.trigger("ccsSpinLoad");
			},
			onFrame: function (e, data) {
				if (rate !== 0) {
					rateCounter++;

					if (rateCounter === rateFramesCount) {
						rateCounter = 0;
						api.stopAnimation();
					}
				}

				$slider.slider("value", data.frame);

				if (!api.isPlaying()) {
					settings.animate = true;
					settings.animate = changePlayPauseState(
						$playPauseBtn,
						api,
						settings.animate,
						settings.toolbox.css.pause);
				}
			}
		});

		$spritespinDiv.trigger("ccsSpinResize");

		api = $spritespinDiv.spritespin("api");

		if (!firstTime)
			return api;

		var playTrigger = false,
			mousedown = false;

		$spritespinDiv.on("mousedown touchstart", function () {
			playTrigger = true;
			mousedown = true;

			setTimeout(function () {
				playTrigger = false;
			}, 200);
		});

		$spritespinDiv.on("mouseup touchend", function (e) {

			if (playTrigger) {
				settings.animate = changePlayPauseState(
					$playPauseBtn,
					api,
					settings.animate,
					settings.toolbox.css.pause);
				playTrigger = false;

				logChangeState(settings);
			} else {
				if (mousedown) {
					logRotate(settings, "drag");
				}
			}

			mousedown = false;
		});

		$spritespinDiv.on("mouseleave", function (e) {
			if (e.buttons !== 0 && mousedown) {
				logRotate(settings, "drag");
			}

			mousedown = false;
		});

		return api;
	}

	function onWindowResize(width, height, $rootContainer, $toolbox, $playPauseBtn, firstTime) {
		var settings = this;

		var widthToSet;
		var heightToSet;
		if ($rootContainer.width() < width) {
			heightToSet = Math.floor($rootContainer.width() * height / width);
			widthToSet = $rootContainer.width();
		} else {
			widthToSet = width;
			heightToSet = height;
		}
		
		var api = initControl.call(settings, widthToSet, heightToSet, $toolbox, $playPauseBtn, firstTime);
		resizeToolbox($toolbox, widthToSet);

		return api;
	}

	function logChangeState(settings) {
		ccs_cc_log.dispatchEvent(settings.logCall, {
			ActionContext: JSON.stringify({
				type: settings.animate ? "play" : "stop"
			})
		});
	}

	function logRotate(settings, type) {
		ccs_cc_log.dispatchEvent(settings.logCall, {
			ActionContext: JSON.stringify({
				type: type
			})
		});
	}

	return {
		setup: setup
	}
});

define('ic/hotspots',["jquery", "ic/utils"], function ($, utils) {

	var c = {
		rootClass: "ccs-hotspots",
		mobileClass: "ccs-hotspots-mobile",
		noScrollClass: "ccs-noscroll",
		pointClass: "ccs-hotspots-point",
		pointActiveClass: "ccs-hotspots-point-active",
		pointSize: 32,
		tooltipTheme: "qtip-light qtip-shadow",
		tooltipsContainerClass: "ccs-hotspots-tooltips",
		tooltipClass: "ccs-hotspots-tooltip",
		videoPlayerClass: "ccs-hotspots-video",

		productTooltipClass: "ccs-hotspots-tooltip-product",
		productPriceClass: "ccs-hotspots-product-price",
		productCartClass: "ccs-hotspots-product-cart",
		customCartClass: "ccs-custom-cart",
		loadingClass: "ccs-loading",

		productAction: "product",
		addToCartAction: "addtocart"
	};
	var defaults = {
		event: "click",
		size: "small",
		iconSet: "ccs-hotspots-default",
		video: {
			autoplay: true
		}
	};

	/*
		media:
			pluginPath
			hotspots
	*/

	function setup(options) {
		if (!options.hotspots) {
			return;
		}

		ccs_require("qtip");

		var o = $.extend(true, {}, defaults, options.hotspots);

		o.video.pluginPath = options.media.pluginPath;

		if (utils.isMobileDevice()) {
			o.event = "click";
		}

		var $body = $("body");
		var $container = $body.find("." + c.tooltipsContainerClass);
		if ($container.length === 0) {
			$container = $("<div>").addClass(c.tooltipsContainerClass).appendTo($body);
		}

		o.$container = $container;

		$("#" + options.inlineContentId)
			.find(".ccs-hotspots-image")
			.each(function () {
				initMainImage(this, o);
			});
	}

	function initMainImage(img, o) {
		var $image = $(img);

		var hotspots = $image.data("hotspots");
		if (hotspots.length === 0) {
			console.warn("No hotspots data was found");
			return;
		}

		$image
			.removeAttr("data-hotspots")
			.wrap($("<div>")
				.addClass(c.rootClass)
				.addClass(o.iconSet));

		initMobile($image, o.$container, hotspots);

		$image.one("load", function () {
			hotspots.forEach(function (hotspot) {
				initHotspot($image, hotspot, o);
			});
		});

		if ($image[0].complete) {
			$image.load();
		}
	}

	function initMobile($img, $container, hotspots) {
		if (!utils.isMobileDevice()) return;

		$container.addClass(c.mobileClass);
		$img.parent().addClass(c.mobileClass);

		for (var i = 0; i < hotspots.length; i++) {
			var hotspot = hotspots[i];

			if (hotspot.type === "video" && hotspot.mediaUrl.match(/\.flv$/)) {
				hotspot.type = "image";
				hotspot.mediaUrl = hotspot.previewUrl;
			}
		}
	}

	function initHotspot($img, hotspot, options) {
		var o = options;

		var position = getPosition(hotspot.position);
		var isProduct = !!hotspot.product;

		var closeButtonBlockTime = o.event === "click" ? 0 : 500;
		var timer, openTime;

		$("<div>")
			.addClass(c.pointClass)
			.addClass(c.pointClass + "-" + hotspot.type)
			.toggleClass(c.productTooltipClass, isProduct)
			.attr("tabindex", 0)
			.css("top", "calc(" + hotspot.y * 100 + "% - " + c.pointSize / 2 + "px)")
			.css("left", "calc(" + hotspot.x * 100 + "% - " + c.pointSize / 2 + "px)")
			.insertBefore($img)
			.qtip({
				prerender: true,
				content: {
					text: buildContent(hotspot, o),
					button: o.event === "click" ? "Close" : false
				},
				show: {
					event: o.event === "click" ? "click" : "mouseenter",
					modal: utils.isMobileDevice()
				},
				hide: {
					fixed: true,
					delay: o.event === "click" ? 0 : 300,
					event: utils.isMobileDevice()
							? false
							: o.event === "click" ? "unfocus" : "mouseleave"
				},
				style: {
					classes: c.tooltipTheme + " " + c.tooltipClass
				},
				position: {
					my: position.my,
					at: position.at,
					effect: false,
					container: o.$container,
					viewport: $(window),
					adjust: {
						method: position.method
					}
				},
				events: {
					render: function(event, api) {
						api.tooltip
							.addClass(c.tooltipClass + "-" + hotspot.type)
							.addClass(c.tooltipClass + "-" + (hotspot.size || o.size))
							.toggleClass(c.productTooltipClass, isProduct)
							.attr("tabindex", 0)
							.on("keydown", function(e) {
								if (e.keyCode === 27) {
									api.hide();
									api.elements.target.focus();
									e.stopPropagation();
								}
							});
							
						api.hotspot = hotspot;

						renderMobile(api);
						renderVideo(api, o);
						renderProduct(api, o);
					},
					show: function (event, api) {
						if (api.tooltip.is(":visible")) {
							return;
						}

						api.elements.target
							.addClass(c.pointActiveClass)
							.blur();

						showMobile(api);

						timer = setTimeout(function () {
							api.elements.target
								.off("click.show")
								.one("click.show", function () { api.hide(); });
						}, closeButtonBlockTime);

						openTime = new Date();
						ccs_cc_log.dispatchEvent(o.logCall, {
							ActionContext: getActionContext("popup-open", $img, api.hotspot)
						});
					},
					visible: function(event, api) {
						api.tooltip.focus();
					},
					hide: function (event, api) {
						api.elements.target
							.removeClass(c.pointActiveClass)
							.off("click.show")
							.one("click.show", function () { api.show(); });

						hideMobile(api);
						clearTimeout(timer);

						ccs_cc_log.dispatchEvent(o.logCall, {
							ActionContext: getActionContext("popup-close", $img, api.hotspot),
							Qty: Math.round((new Date() - openTime) / 1000)
						});
					}
				}
			})
			.keyup(function (event) {
				if (event.keyCode === 13) {
					$(this).qtip("show");

				} else if (event.keyCode === 27) {
					$(this).qtip("hide");
				}
			});
	}

	function getPosition(position) {

		if (utils.isMobileDevice())
			return {
				my: "center",
				at: "center",
				method: "none"
			};

		switch (position) {

			case "left":
				return {
					my: "center right",
					at: "center left",
					method: "flip shift"
				};

			case "right":
				return {
					my: "center left",
					at: "center right",
					method: "flip shift"
				};

			case "bottom":
				return {
					my: "top center",
					at: "bottom center",
					method: "shift flip"
				};

			default:
				return {
					my: "bottom center",
					at: "top center",
					method: "shift flip"
				};
		}
	}

	function getActionContext(type, $img, hotspot) {
		var data = {
			type: type,
			hotspot: {
				mainImage: $img.attr("src"),
				type: hotspot.type,
				x: +hotspot.x.toFixed(4),
				y: +hotspot.y.toFixed(4)
			}
		};

		return JSON.stringify(data);
	}

	function buildContent(data, o) {
		var $wrap = $("<div>");

		$wrap.append(
			buildMediaContent(data));

		if (data.title)
			$wrap.append($("<h4>").html(data.title));

		if (data.description)
			$wrap.append($("<div>", { html: data.description }));

		if (data.product)
			$wrap = buildProductContent($wrap, data, o);

		return $wrap;
	}

	function buildMediaContent(data) {
		if (!data.mediaUrl)
			return false;

		return data.type === "video"
			? $("<div>").addClass(c.videoPlayerClass)
			: $("<img>", { src: data.mediaUrl, alt: data.title });
	}

	function buildProductContent($wrap, data, o) {
		wrapIntoProductLink($wrap, data, o.crossSell);

		return $wrap
			.append(buildProductPrice(data, o))
			.append(buildProductAddToCart(data, o));
	}

	function wrapIntoProductLink($content, data, options) {
		if (!data.product.url || !$content.is(":parent"))
			return;

		var $eventTargets = $content.find("img, h4");

		var $span = $("<span>")
			.attr("data-logo-productLink", true)
			.attr("data-logo-event", options.logCall)
			.data("logo-event-params", { ActionContext: data.product.logData });

		var $link = $("<a>")
			.attr("href", data.product.url)
			.attr("target", options.target || "_blank");

		$eventTargets.wrap($span).wrap($link);
	}

	function buildProductPrice(data, o) {
		var price = data.product.price;

		if (!price) return null;

		var $block = $("<div>").addClass(c.productPriceClass);

		if (price.value && !o.crossSell.parsingJs) {
			$block.text(price.value);
		}

		return $block;
	}

	function buildProductAddToCart(data, o) {
		var addToCart = data.product.addToCart;
		if (!addToCart)
			return null;

		var logData = null;
		if (data.product.logData) {
			var context = JSON.parse(data.product.logData);
			context.type = c.addToCartAction;

			logData = { ActionContext: JSON.stringify(context) };
		}

		return $("<div>")
			.addClass(c.productCartClass)
			.toggleClass(c.customCartClass, addToCart.isCustom === true)
			.html(addToCart.html)
			.children()
			.attr("data-logo-event", o.crossSell.logCall)
			.data("logo-event-params", logData)
			.parent();
	}

	function renderVideo(api, o) {
		var hotspot = api.hotspot;
		if (hotspot.type !== "video")
			return;

		api.tooltip
			.toggleClass(c.tooltipClass + "-video-only", !hotspot.title && !hotspot.description)
			.one("tooltipshow", function () {
				var $content = api.elements.content;
				var $player = $content.find("." + c.videoPlayerClass);
				var isMobile = utils.isMobileDevice();

				var settings = {
					file: api.hotspot.mediaUrl,
					transcodedFile: api.hotspot.transcodedUrl,
					image: isMobile ? api.hotspot.previewUrl : null,
					ccUrl: api.hotspot.ccUrl,
					ccLang: api.hotspot.ccLang,
					ccForceOnYouTube: api.hotspot.forceYouTubeCC,
					height: isMobile ? "100%" : $content.height(),
					width: isMobile ? "100%" : $content.width(),
					mute: false,
					volume: 80,
					autoplay: !isMobile && o.video.autoplay,
					pluginPath: o.video.pluginPath,
					showNativeButton: isMobile,
					tracking: {
						clientParams: utils.makeClientParams(api.target),
						videoEventData: o.video.logCall
					}
				};

				var player = api.player = $player.ccsVideoPlayer(settings);

				api.tooltip.on("tooltiphide", function () { player.pause(); });

				if (settings.autoplay) {
					api.tooltip.on("tooltipshow", function () { player.play(); });
				}
			});
	}

	function renderProduct(api, options) {
		var hotspot = api.hotspot;
		if (!hotspot.product)
			return;

		var $tooltip = api.tooltip;
		var price = hotspot.product.price;
		var o = options.crossSell;

		CcsLogoProgram.scanEvents($tooltip.attr("id"));

		if (price && price.apiUrl && o && o.parsingJs) {
			$tooltip.one("tooltipshow", function () {
				var $block = $tooltip
								.find("." + c.productPriceClass)
								.addClass(c.loadingClass);

				CcsLogoProgram.requestPrice(
					function (response) {
						if (response.result) {
							$block.text(response.result);
						}
						$block.removeClass(c.loadingClass);
						$tooltip.qtip("reposition");
					},
					price.apiUrl,
					o.parsingJs,
					o.errorLogCall);
			});
		}
	}

	function renderMobile(api) {
		if (!utils.isMobileDevice()) return;

		window
			.matchMedia("(orientation: portrait)")
			.addListener(function () {
				if (api.tooltip.is(":visible")) {
					if (api.hotspot.type === "video" && api.player) {
						var player = api.player.getPlayer();
						player.mejs.exitFullScreen();
					}

					api.hide();
				}
			});
	}

	function hideMobile(api) {
		if (!utils.isMobileDevice()) return;

		$("body").removeClass(c.noScrollClass);
	}

	function showMobile(api) {
		if (!utils.isMobileDevice()) return;

		$("body").addClass(c.noScrollClass);

		var screenSize = getScreenSize();

		api.set("position.target", getScreenCenter(screenSize));

		if (api.hotspot.type === "video") {
			setVideoSize(api, screenSize);
		} else {
			setDefaultSize(api, screenSize);
		}
	}

	function setDefaultSize(api, s) {
		var $content = $(api.elements.content);

		$content.add($content.find("img")).css({
				"max-width": s.innerWidth + "px",
				"max-height": s.innerHeight + "px"
			});
	}

	function setVideoSize(api, s) {
		var $content = $(api.elements.content);
		var h = Math.min((s.width - s.margin) / (16 / 9), s.innerHeight);

		$content.css({
			"max-width": s.innerWidth + "px",
			"max-height": s.innerHeight + "px"
		});

		$content.find("." + c.videoPlayerClass)
			.css({
				height: h + "px",
				width: s.innerWidth + "px"
			});

		if (api.player)
			api.player.mejs.resetSize();
	}

	function getScreenSize() {
		var width = window.innerWidth
			? window.innerWidth
			: document.documentElement.clientWidth
				? document.documentElement.clientWidth
				: screen.width;

		var height = window.innerHeight
			? window.innerHeight
			: document.documentElement.clientHeight
				? document.documentElement.clientHeight
				: screen.height;

		var margin = Math.round(Math.min(width, height) * 0.2);

		return {
			width: width,
			height: height,
			margin: margin,
			innerWidth: width - margin,
			innerHeight: height - margin
		};
	}

	function getScreenCenter(screen) {
		var $w = $(window);
		return [screen.width / 2 + $w.scrollLeft(), screen.height / 2 + $w.scrollTop()];
	};

	return {
		setup: setup
	};
});
require(["jquery", "ic/base", "ic/spin", "ic/hotspots"], function ($, base, spin, hotspots) {

	base.setup(options);
	spin.setup(options);
	hotspots.setup(options);
});

define("main", function(){});

}}());
